import React, { useState, useEffect} from 'react';
import { HOST } from '../components/config';

import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
const OrganizationSelector = () => {
  
  const [activeOrgId, setActiveOrgId] = useState(localStorage.getItem('org_id'))
  const [organizations, setOrganizations] = useState([])
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setActiveOrgId(value)
    localStorage.setItem('org_id', value);
    window.location.href = '/cases'
  }

  const loadOrganizations = () => {
      const token =  localStorage.getItem('token')    ;
      if (!token)
        return
      try {
        fetch(HOST + '/api/organizations/',
        {   
          "method": "GET",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
         })
        .then((res) => res.json())
        .then((json) => {
          if (activeOrgId == null && json.length) {
            setActiveOrgId(json[0].id)
            localStorage.setItem('org_id', json[0].id);
          }
          if (Array.isArray(json)) { 
            setOrganizations(json)
          }
       })
      } catch (err) {
          debugger;
          setOrganizations([]);
          localStorage.removeItem('token')
          console.log(err);
      } finally {
      }
  }
  
  useEffect( () => {
    loadOrganizations() 
  }, [])

  return (
            <>
            {organizations.length > 0 &&
              <Select
                sx={{ 
                  '& .MuiSvgIcon-root': { // Target the SVG icon
                    color: 'white', // Change to your desired color
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#A9A9A9'
                  },
                  color: "white", border: "white", fontWeight: 700 }}
                labelId="add-doc-type-label"
                
                name="org_id"
                value={activeOrgId}
                onChange={handleInputChange}
                >
                {organizations.map((org)=> 
                  <MenuItem 
                    key={"org-" + org.id}
                    value={org.id}>
                      {org.name}
                  </MenuItem>)}
              </Select>
            }
            </>
  );
}

export default OrganizationSelector;
